var render = function render(){var _vm=this,_c=_vm._self._c;return _c('public-layout',[_c('div',{staticClass:"container mx-auto p-6 content-center md:py-12 lg:px-12 md:w-1/2 xl:w-1/3"},[_c('div',{staticClass:"flex flex-col px-6 py-8 shadow-2xl rounded bg-white lg:px-12"},[_c('register-form')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }